// Mock teacher data for demonstration
export const mockTeachers = [
  {
    id: 1,
    name: '陳老師',
    englishName: 'Chan Sir',
    subject: '中文',
    position: '中文科主任',
    email: 'chan.sir@school.edu.hk',
    phone: '2345-6789',
    office: 'A座3樓301室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港大學中文系碩士',
    experience: '15年',
    specializations: ['中國文學', '寫作技巧', '古典詩詞'],
    classes: ['6A', '6B', '5A'],
    photo: null,
    bio: '專注於中文教學15年，致力於提升學生的中文寫作和文學欣賞能力。',
    isAvailable: true
  },
  {
    id: 2,
    name: '李老師',
    englishName: 'Lee Sir',
    subject: '英文',
    position: '英文科主任',
    email: 'lee.sir@school.edu.hk',
    phone: '2345-6790',
    office: 'A座3樓302室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港中文大學英文系碩士',
    experience: '12年',
    specializations: ['英語會話', '閱讀理解', '寫作技巧'],
    classes: ['6A', '6B', '5B'],
    photo: null,
    bio: '擁有豐富的英語教學經驗，專注於提升學生的英語溝通能力。',
    isAvailable: true
  },
  {
    id: 3,
    name: '王老師',
    englishName: 'Wong Sir',
    subject: '數學',
    position: '數學科主任',
    email: 'wong.sir@school.edu.hk',
    phone: '2345-6791',
    office: 'A座3樓303室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港科技大學數學系碩士',
    experience: '18年',
    specializations: ['代數', '幾何', '統計學'],
    classes: ['6A', '6B', '5A', '5B'],
    photo: null,
    bio: '數學教學專家，善於將複雜的數學概念簡化，讓學生容易理解。',
    isAvailable: true
  },
  {
    id: 4,
    name: '張老師',
    englishName: 'Cheung Sir',
    subject: '科學',
    position: '科學科主任',
    email: 'cheung.sir@school.edu.hk',
    phone: '2345-6792',
    office: 'B座2樓201室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港大學生物學系碩士',
    experience: '14年',
    specializations: ['生物學', '化學', '物理學'],
    classes: ['6A', '6B', '5A', '5B'],
    photo: null,
    bio: '熱愛科學教育，致力於培養學生的科學思維和實驗能力。',
    isAvailable: true
  },
  {
    id: 5,
    name: '劉老師',
    englishName: 'Lau Sir',
    subject: '體育',
    position: '體育科主任',
    email: 'lau.sir@school.edu.hk',
    phone: '2345-6793',
    office: '體育館1樓101室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港教育大學體育系學士',
    experience: '10年',
    specializations: ['田徑', '球類運動', '體能訓練'],
    classes: ['6A', '6B', '5A', '5B'],
    photo: null,
    bio: '專業體育教師，注重培養學生的運動技能和體育精神。',
    isAvailable: true
  },
  {
    id: 6,
    name: '黃老師',
    englishName: 'Wong Miss',
    subject: '音樂',
    position: '音樂科主任',
    email: 'wong.miss@school.edu.hk',
    phone: '2345-6794',
    office: '音樂室1樓102室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港演藝學院音樂系學士',
    experience: '8年',
    specializations: ['鋼琴', '聲樂', '音樂理論'],
    classes: ['6A', '6B', '5A', '5B'],
    photo: null,
    bio: '專業音樂教師，致力於培養學生的音樂素養和表演能力。',
    isAvailable: true
  },
  {
    id: 7,
    name: '林老師',
    englishName: 'Lam Sir',
    subject: '美術',
    position: '美術科主任',
    email: 'lam.sir@school.edu.hk',
    phone: '2345-6795',
    office: '美術室1樓103室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港中文大學藝術系學士',
    experience: '11年',
    specializations: ['繪畫', '設計', '藝術史'],
    classes: ['6A', '6B', '5A', '5B'],
    photo: null,
    bio: '專業美術教師，善於激發學生的創意和藝術潛能。',
    isAvailable: true
  },
  {
    id: 8,
    name: '何老師',
    englishName: 'Ho Sir',
    subject: '電腦',
    position: '電腦科主任',
    email: 'ho.sir@school.edu.hk',
    phone: '2345-6796',
    office: '電腦室2樓202室',
    officeHours: '週一至週五 8:00-17:00',
    qualifications: '香港科技大學計算機科學系碩士',
    experience: '9年',
    specializations: ['程式設計', '多媒體製作', '網絡技術'],
    classes: ['6A', '6B', '5A', '5B'],
    photo: null,
    bio: '專業電腦教師，致力於培養學生的數碼素養和創新能力。',
    isAvailable: true
  }
];

// Helper function to get teachers by subject
export const getTeachersBySubject = (subject) => {
  return mockTeachers.filter(teacher => teacher.subject === subject);
};

// Helper function to get teachers by position
export const getTeachersByPosition = (position) => {
  return mockTeachers.filter(teacher => teacher.position === position);
};

// Helper function to get available teachers
export const getAvailableTeachers = () => {
  return mockTeachers.filter(teacher => teacher.isAvailable);
};

// Helper function to search teachers by name
export const searchTeachersByName = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return mockTeachers.filter(teacher => 
    teacher.name.toLowerCase().includes(term) || 
    teacher.englishName.toLowerCase().includes(term)
  );
};

// Helper function to get teachers by class
export const getTeachersByClass = (className) => {
  return mockTeachers.filter(teacher => teacher.classes.includes(className));
};
